import { createRouter, createWebHistory } from 'vue-router';
import ApplyPage from '@/pages/ApplyPage.vue';
import HomePage from '@/pages/HomePage.vue';
import CompletePage from '@/pages/CompletePage.vue';
import KYC from '@/pages/KYC.vue';
import SchemaFormPage from '@/pages/SchemaFormPage.vue';
// import StartPage from '@/pages/StartPage.vue';

const routes = [
  { path: '/', name: 'Home', component: HomePage },
  { 
    path: '/apply/:params', 
    name: 'Apply', 
    component: ApplyPage,
    props: true
  },

  { 
    path: '/complete/:params', 
    name: 'Complete', 
    component: CompletePage,
    
  },

  { 
    // path: '/kyc/:params', 
    path: '/kyc', 
    name: 'KYC', 
    component: KYC,
    
  },
  {
    path: '/schema-form',
    name: 'SchemaForm',
    component: SchemaFormPage,
  },
  // { path: '/start', name: 'Start', component: StartPage },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
